import { actions } from './partner_clinic_report/actions'
import { getters } from './partner_clinic_report/getters'
import { state } from './partner_clinic_report/state'
import { mutations } from './partner_clinic_report/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}